// components
import { Divider, Tooltip } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

// types
import { ToolbarActionProps } from './ToolbarAction.types';
import { PulsingBadge } from 'components/shared/Badge/PulsingBadge';
import { StyledRelativeBox } from 'components/shared/Box/Box.styles';

const ToolbarAction = ({
  action,
  isRightPositioned = false
}: ToolbarActionProps) => {
  return (
    <>
      {action.leftDivider && (
        <Divider
          orientation={isRightPositioned ? 'horizontal' : 'vertical'}
          variant="middle"
          flexItem
        />
      )}
      <Tooltip
        title={action.tooltipLabel}
        placement={isRightPositioned ? 'left' : 'bottom'}
      >
        <StyledRelativeBox>
          <IconButton
            id={action.id}
            onClick={action.onClick}
            type={action.icon}
            size="small"
            data-tourid={action.actionDataTourId}
            disabled={action.disabled}
          />
          {action?.pulsingBadge?.isActive && (
            <PulsingBadge
              color="primary"
              content={action?.pulsingBadge?.content ?? ''}
            />
          )}
        </StyledRelativeBox>
      </Tooltip>
      {action.rightDivider && (
        <Divider
          orientation={isRightPositioned ? 'horizontal' : 'vertical'}
          variant="middle"
          flexItem
        />
      )}
    </>
  );
};

export default ToolbarAction;
